import React from 'react';
import Footer from '../component/Footer';
import AboutContent from '../component/AboutContent';
import '../style/index.css';

function About() {
    return (
        <div>
            <AboutContent />
            <Footer />
        </div>
    );
}

export default About;
